export default __webpack_public_path__ + "static/media/gt.4cfc71f2.jpg";